import { connect } from 'react-redux';
import * as FilterActions from '../../actions/filter-actions';
import PressReleases from './PressReleases';

const mapStateToProps = state => ({
  filters: state.filters,
  articleItems: state.articleItems,
  noResultsMessage: state.noResultsMessage,
  articlesListLinkText: state.articlesListLinkText,
  selectedFilters: state.selectedFilters,
  filterToggle: state.filterToggle,
});

const mapDispatchToProps = dispatch => ({
  filterClick: (event, filter, option) => dispatch(FilterActions.filterClick(event, filter, option)),
  clearFilters: () => dispatch(FilterActions.clearFilters()),
});

const PressReleasesContainer = connect(mapStateToProps, mapDispatchToProps)(PressReleases);

export default PressReleasesContainer;
